import React from 'react'
import '../assets/css/sub-pages.css'
import Section6 from '../pages/homepage/Section6'
import { Helmet } from 'react-helmet'
import Section1 from '../components/features-component/Section1'
import Section2 from '../components/features-component/Section2'
import Section3 from '../components/features-component/Section3'
import Section4 from '../components/features-component/Section4'
import Section5 from '../components/features-component/Section5'
import FeaturesSlider from '../components/features-component/FeaturesSlider'
import Faqs from '../components/features-component/Faqs'
import Feature1 from '../assets/images/fin-rec-asset/Promotions/Budget Planning.webp'
import Feature2 from '../assets/images/fin-rec-asset/Promotions/Smart Campaign Design.webp'
import Feature3 from '../assets/images/fin-rec-asset/Promotions/End-to-End Campaign Management.webp'
import Feature4 from '../assets/images/fin-rec-asset/Promotions/Real-Time Campaign Performance.webp'
import Play_btn from './../assets/images/play_supply.svg'
import Promotion_hero from '../assets/images/Promotions_hero.png'

const PromotionsNew = () => {

    const sec1data = {
        heading: "Third-Party Delivery Service Ads & Promotions-Done For You!",
        subText: "Restaurants often struggle to see how promotional spending directly impacts their bottom line. Hidden inefficiencies, unclear ROI, and ineffective ad spend management can lead to wasted budgets and missed growth opportunities. Voosh Ads & Promotions Consulting transforms your promotional strategy—ensuring each dollar spent drives maximum profitability on third-party platforms like DoorDash and Uber Eats.",
        btnText: "Start Optimizing My Promotions",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal",
        ytVideoID: "no_vid",
        thumbnail: Promotion_hero,
        thumbText: "",
        playBtn: Play_btn,
        
    }

    const s2SecHead = {
        subHead: "Why Voosh Ads & Promotions Consulting?",
        heading: "See exactly where your promotional dollars are going.",
        p1: "Instantly Improve Promotional ROI",
        p2: "Eliminate Wasted Ad Spend",
        p3: "Real-time Campaign Insights",
        p4: "Automate Campaign Management",
    }

    const s2CardContents = [
        {
            id: '01',
            title: 'Budget Planning',
            image: Feature1,
            Problem: 'Restaurants frequently overspend on ads and promos without clear visibility into true ROI, missing opportunities for growth and profitability.',
            Solution: "Voosh analyzes your entire ad and promotional spend across all locations, flags overspending, and strategically reallocates budgets to maximize profitability.",
            Benefits: 'Clearly understand your promotional spend\'s impact on your bottom line, compare performance against industry benchmarks, and stay competitively positioned.',
            p1: 'Spot payout discrepancies instantly',
            p2: 'Track hidden charges and adjustments clearly',
            p3: 'Automate accounting entries',
        },
        {
            id: '02',
            title: 'Smart Campaign Design',
            image: Feature2,
            Problem: 'Generic promotional strategies fail to engage customers effectively, resulting in low ROI and missed sales opportunities.',
            Solution: "Voosh creates customized campaigns tailored to your sales data, customer behavior, and growth objectives, ensuring your promos resonate with customers.",
            Benefits: 'Unlock detailed insights into customer engagement, drive targeted actions, and boost sales through optimized promotional strategies.',
            p1: 'Identify order discrepancies in real-time',
            p2: 'Reduce manual verification processes',
            p3: 'Quickly recover lost revenue',
        },
        {
            id: '03',
            title: 'End-to-End Campaign Management',
            image: Feature3,
            Problem: 'Managing multiple promotional campaigns on third-party platforms can become complex and time-consuming, causing operational distractions.',
            Solution: "Voosh fully manages your third-party promotional campaigns—from testing and tracking to real-time optimization—freeing your team to focus on restaurant operations.",
            Benefits: 'Effortlessly scale successful promotions, eliminate ineffective campaigns quickly, and consistently improve your third-party platform returns.',
            p1: 'Automatically detect delayed or missing deposits',
            p2: 'Streamline reconciliation processes',
            p3: 'Ensure daily cash flow accuracy',
        },
        {
            id: '04',
            title: 'Real-Time Campaign Performance',
            image: Feature4,
            Problem: 'Delayed insights lead to outdated campaign decisions, lost revenue opportunities, and stagnant promotional effectiveness.',
            Solution: "Voosh provides real-time monitoring of critical performance metrics (CAC, ROAS, redemption rates) to swiftly adapt your promotional strategies.",
            Benefits: 'Act instantly on data-driven insights, maintain agility, and maximize promotional ROI consistently across all locations.',
            p1: 'Eliminate manual journal entry',
            p2: 'Ensure precise financial records',
            p3: 'Scale effortlessly with your business',
        },
    ]

    const sec3data ={
        heading: "Integrations for Optimal Promotional Clarity",
        subHead1: "",
        p1: "",
        subHead2: "",
        p2: "Voosh seamlessly integrates with leading third-party platforms—DoorDash and Uber Eats—ensuring your campaigns are accurately tracked and optimized to drive profitability.",
        btnText: "Request Integration",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal",
    }

    const sec4data = {
        heading: "Why Marketing Teams Choose Voosh",
        subHead1: "Proven Results",
        p1: "Increase ROI by up to 25%, streamline your marketing spend, and drive consistent growth across third-party platforms.",
        subHead2: "Custom Solutions",
        p2: "Personalized promotional strategies aligned precisely with your unique sales data and customer behaviors.",
        subHead3: "Operational Freedom",
        p3: "End-to-end campaign management lets you focus on your restaurant while Voosh boosts your profitability.",
    }

    const sec5data = {
        heading: "Get clarity and profitability in every promotion!",
        subText: "Schedule your personalized promotions review with Voosh today, and start turning every promotional dollar into measurable profit.",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018",

    }

    const faq_data = [
        {
            id: '0',
            head: 'What exactly does Voosh Promotions Consulting offer?',
            body: "We help restaurants maximize their ROI from promotional spending by optimizing budgets, designing effective campaigns, and providing real-time performance insights."
        },
        {
            id: '1',
            head: "How quickly will I see results?",
            body: "Most restaurants see measurable improvements within weeks of implementation, with ongoing optimization for continuous gains."
        },
        {
            id: '2',
            head: "Can Voosh integrate with existing promotional tools?",
            body: "Yes, Voosh seamlessly integrates with your existing third-party delivery platforms and marketing analytics tools."
        },
        {
            id: '3',
            head: "Is my promotional data secure with Voosh?",
            body: "Absolutely. Voosh adheres to industry-leading data security practices to ensure your promotional data remains confidential and secure."
        }
      ]

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <Helmet>
        <title>Third-Party Delivery Service Ads & Promotions—Done For You!</title>
        <meta name='description' content="Manage and respond to customer reviews across platforms effortlessly with Voosh's Review Manager" />
        <meta name='keywords' content='DoorDash Promotions, GrubHub Promotions, Uber Eats Promotions, Benefits Of Promotions, Boost Sales, Brand Reputation, Customer Experience, Dispute Management, Drive Sales, Effective Promotions, Increase Visibility, Manage Promotions, Marketing Strategy, Pitfalls To Avoid, Promotions Management, Restaurant Promotions, Reviews Management, Third-Party Marketplaces, Third-Party Platforms, Timing Promotions, Types Of Promotions, DoorDash, UberEats, GrubHub' />
    </Helmet>
      <Section1 datas = {sec1data} />
      <Section2 s2Contents = {s2CardContents} datas = {s2SecHead} />
      <Section3 datas = {sec3data} />
      <Section4 datas = {sec4data} />
      <Section5 datas = {sec5data} />
      <FeaturesSlider />
      <Faqs datas={faq_data} />
      <Section6 />
    </div>
  )
}

export default PromotionsNew
